import React from 'react';
import '../../styles/pages.css';

export default function SendSingleSms() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Send Single SMS</h1>
        <p>Send SMS to a single recipient</p>
      </div>
      <div className="page-section">
        <form style={{ maxWidth: '600px' }}>
          <div className="form-group">
            <label>Recipient Phone Number</label>
            <input type="tel" placeholder="+254712345678" style={{ width: '100%', padding: '0.75rem', border: '1px solid #e2e8f0', borderRadius: '8px' }} />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea rows="4" style={{ width: '100%', padding: '0.75rem', border: '1px solid #e2e8f0', borderRadius: '8px' }} placeholder="Type your message here..."></textarea>
          </div>
          <button type="submit" className="btn-primary">Send</button>
        </form>
      </div>
    </div>
  );
}
